import React from 'react'
import LeadSummaryCallingCardComponent from './LeadSummaryCallingCardComponent';
import LeadSummaryResponseTimeCardComponent from './LeadSummaryResponseTimeCardComponent';
import LeadSummaryFollowupCardComponent from './LeadSummaryFollowupCardComponent';
import LeadSummaryStatusUpdateCardComponent from './LeadSummaryStatusUpdateCardComponent';

interface LeadSummaryCardComponentProps {
    data: any,
}

const LeadSummaryCardComponent: React.FC<LeadSummaryCardComponentProps> = ({ data }) => {

    return (
        <>
            {
                (data.cardTitle === "Calling") &&
                <LeadSummaryCallingCardComponent data={data} />
            }
            {
                (data.cardTitle === "Response Time") &&
                <LeadSummaryResponseTimeCardComponent data={data} />
            }
            {
                (data.cardTitle === "Follow-up Calls") &&
                <LeadSummaryFollowupCardComponent data={data} />
            }
            {
                (data.cardTitle === "Status Updates") &&
                <LeadSummaryStatusUpdateCardComponent data={data} />
            }
        </>
    )
}

export default LeadSummaryCardComponent